export default __webpack_public_path__ + "static/media/rmall-project-4.2169e35f.webp";